import { enums, nullable, number, object, optional, string } from "superstruct";

import {
    REWARDS_BRANDING_FONT_COLOR_TYPES,
    REWARDS_BRANDING_LAUNCHER_ICON_TYPES,
    REWARDS_BRANDING_LAUNCHER_POSITION_TYPES,
    REWARDS_BRANDING_LAUNCHER_STYLE_TYPES,
    REWARDS_BRANDING_LAUNCHER_VISIBILITY_TYPES,
    REWARDS_BRANDING_POPUP_VIEW_TYPES,
    REWARDS_BRANDING_THEME_COLOR_TYPES,
    REWARDS_BRANDING_WIDGET_TYPES,
} from "../../../constants/rewardsBrandingTypes";

const RewardsBrandingLauncherPositionSchema = object({
    side: number(),
    bottom: number(),
});

const RewardsStorefrontValuesBrandingThemeColorSchema = enums([
    REWARDS_BRANDING_THEME_COLOR_TYPES.primaryColor,
    REWARDS_BRANDING_THEME_COLOR_TYPES.secondaryColor,
]);

const RewardsStorefrontValuesBrandingFontColorSchema = enums([
    REWARDS_BRANDING_FONT_COLOR_TYPES.white,
    REWARDS_BRANDING_FONT_COLOR_TYPES.black,
]);

const RewardsStorefrontValuesBrandingSchema = object({
    general: object({
        theme: object({
            primaryColor: string(),
            secondaryColor: string(),
        }),
        buttons: object({
            themeColor: RewardsStorefrontValuesBrandingThemeColorSchema,
            fontColor: RewardsStorefrontValuesBrandingFontColorSchema,
        }),
        content: object({
            iconsThemeColor: RewardsStorefrontValuesBrandingThemeColorSchema,
            linksThemeColor: RewardsStorefrontValuesBrandingThemeColorSchema,
        }),
        widget: optional(
            object({
                type: enums([
                    REWARDS_BRANDING_WIDGET_TYPES.popUpWidget,
                    REWARDS_BRANDING_WIDGET_TYPES.drawerWidget,
                ]),
            })
        ),
    }),
    popUpWidget: object({
        launcher: object({
            appearance: object({
                themeColor: RewardsStorefrontValuesBrandingThemeColorSchema,
                fontColor: RewardsStorefrontValuesBrandingFontColorSchema,
                style: enums([
                    REWARDS_BRANDING_LAUNCHER_STYLE_TYPES.iconWithText,
                    REWARDS_BRANDING_LAUNCHER_STYLE_TYPES.textOnly,
                    REWARDS_BRANDING_LAUNCHER_STYLE_TYPES.iconOnly,
                ]),
            }),
            icon: object({
                type: enums([
                    REWARDS_BRANDING_LAUNCHER_ICON_TYPES.default,
                    REWARDS_BRANDING_LAUNCHER_ICON_TYPES.gift,
                    REWARDS_BRANDING_LAUNCHER_ICON_TYPES.ticket,
                    REWARDS_BRANDING_LAUNCHER_ICON_TYPES.star,
                    REWARDS_BRANDING_LAUNCHER_ICON_TYPES.ribbon,
                ]),
                color: RewardsStorefrontValuesBrandingFontColorSchema,
                customUrl: optional(nullable(string())),
            }),
            position: object({
                placement: enums([
                    REWARDS_BRANDING_LAUNCHER_POSITION_TYPES.bottomRight,
                    REWARDS_BRANDING_LAUNCHER_POSITION_TYPES.bottomLeft,
                ]),
                desktop: RewardsBrandingLauncherPositionSchema,
                mobile: RewardsBrandingLauncherPositionSchema,
            }),
            visibility: object({
                device: enums([
                    REWARDS_BRANDING_LAUNCHER_VISIBILITY_TYPES.allDevices,
                    REWARDS_BRANDING_LAUNCHER_VISIBILITY_TYPES.desktopOnly,
                    REWARDS_BRANDING_LAUNCHER_VISIBILITY_TYPES.hide,
                ]),
            }),
        }),
        popUpContent: object({
            banner: object({
                themeColor: RewardsStorefrontValuesBrandingThemeColorSchema,
                fontColor: RewardsStorefrontValuesBrandingFontColorSchema,
                programName: string(),
                image: nullable(string()),
            }),
            view: enums([
                REWARDS_BRANDING_POPUP_VIEW_TYPES.home,
                REWARDS_BRANDING_POPUP_VIEW_TYPES.waysToEarnPoints,
                REWARDS_BRANDING_POPUP_VIEW_TYPES.waysToSpendPoints,
                REWARDS_BRANDING_POPUP_VIEW_TYPES.vipTiers,
            ]),
        }),
    }),
});

export default RewardsStorefrontValuesBrandingSchema;
